import { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { FieldShell } from './FieldShell';
import { useFieldName, useDomFieldId } from './_useFieldName';
import { onResolveAutoComplete, FIELD_NO_AUTOFILL, onNoAutofillProps } from './_fieldDefaults';

const BLOCK = 'LStudio__app_field';

/*
    🔥 INPUT — text, email, password, number, tel, url, search, date, time

    Sin autocompletado ni autofill. Si en algún campo SÍ lo querés
    (una dirección de envío, por ejemplo), pasale autoComplete="street-address"
    y noAutofill={false}.
*/

export const FieldInput = ({
    id, name, label, hint, error, type = 'text',
    value, onChange, placeholder,
    iconStart = null, iconEnd = null,
    autoComplete = null, noAutofill = true,
    isRequired = false, isDisabled = false, isReadOnly = false,
    span = 1, onFocus = null, onBlur = null, ...rest
}) => {

    const [useIsVisible, setIsVisible] = useState(false);

    /*
        type="pin" se ve como una contraseña pero para el navegador es un
        campo de texto comun: no aparece el cartel de "¿guardar contraseña?".
    */
    const IS_PIN = type === 'pin';

    const IS_PASSWORD = type === 'password' || IS_PIN;

    const REAL_TYPE = IS_PIN ? 'text' : (IS_PASSWORD && useIsVisible ? 'text' : type);

    const GUARD = noAutofill ? onNoAutofillProps({ isReadOnly, isDisabled }) : {};

    const { domName, onChangeField, onBlurField } = useFieldName({ id, name, onChange, onBlur, isEnabled: noAutofill });

    const onHandleFocus = (event) => {
        GUARD.onFocus?.(event);
        onFocus?.(event);
    };

    const DOM_ID = useDomFieldId(id);

    return (
        <FieldShell id={DOM_ID} label={label} hint={hint} error={error}
            isRequired={isRequired} isDisabled={isDisabled} span={span} >

            <div className={`${BLOCK}__wrap`}>

                {iconStart && <span className={`${BLOCK}__icon ${BLOCK}__icon--start`}>{iconStart}</span>}

                <input id={DOM_ID} data-field={name ?? id} name={domName} type={REAL_TYPE}
                    className={`${BLOCK}__input`}
                    value={value ?? ''} onChange={onChangeField} onBlur={onBlurField}
                    placeholder={placeholder}
                    autoComplete={onResolveAutoComplete(IS_PIN ? 'text' : type, autoComplete)}
                    required={isRequired} disabled={isDisabled}
                    aria-invalid={!!error}
                    data-has-start={!!iconStart} data-has-end={!!iconEnd || IS_PASSWORD}
                    data-masked={IS_PIN ? String(!useIsVisible) : undefined}
                    {...FIELD_NO_AUTOFILL}
                    {...GUARD}
                    readOnly={isReadOnly || GUARD.readOnly}
                    onFocus={onHandleFocus}
                    {...rest} />

                {
                    IS_PASSWORD
                        ? (
                            <button type="button" className={`${BLOCK}__icon ${BLOCK}__icon--end ${BLOCK}__icon--button`}
                                aria-label={useIsVisible ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                                onClick={() => setIsVisible(!useIsVisible)} >
                                {useIsVisible ? <FaEyeSlash /> : <FaEye />}
                            </button>
                        )
                        : iconEnd && <span className={`${BLOCK}__icon ${BLOCK}__icon--end`}>{iconEnd}</span>
                }

            </div>

        </FieldShell>
    );
};
